





























import { computed, defineComponent } from 'vue-demi';
import { FitHalfScreenDialog, FitButton } from '@tencent/wphk-ui';
import { url } from '@tencent/wphk-base-utils';
import { useSessionStorage } from '@vueuse/core';
import { CharityIcon } from '@tencent/wphk-icon-vue/fps';

export default defineComponent({
  name: 'PaymentTipsDialog',
  components: {
    FitHalfScreenDialog,
    FitButton,
    CharityIcon,
  },
  setup() {
    /** 参数中是否有标记 */
    const hasShowParams = url.getUrlParam('isShowPayTipsDialog');
    /** session 中是否有展示过 */
    const isTipsShowed = useSessionStorage('isShowPayTipsDialog', false);
    const isNeedShowTips = computed(() => hasShowParams && !isTipsShowed.value);

    const hideTips = () => {
      isTipsShowed.value = true;
    };
    return {
      isNeedShowTips,
      hideTips,
    };
  },
});
